export default __webpack_public_path__ + "static/media/gratefl-solar-bg.b74ce785.jpeg";